import React, {Component} from 'react'
import CInput from '@/components/CForm/CInput'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { postLogin,loginPhone,fixToken,selecttype,loginout} from "@/servers/commonApi";
import { setStorage} from "@/utils";
import { setBreadcrumb} from "@/redux/common/action";
import { withRouter} from 'react-router-dom'
import {setMenu, setUserInfo, setUserList} from "../../redux/common/action";
import { connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import './index.scss'
import Time from './components/count'
import {Modal, message} from "antd";
import { loginStatusSelect} from "@/servers/goodsManageApi";

@CBaseComponent
class Login extends Component{
  onRef(ref){this.child = ref}
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.changHandler = this.changHandler.bind(this);
    this.onChange = this.onChange.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }
  state = {
    mobile:'',
    vcode:'',
    loginid: '',
    password: '',
    type: 'phone',
    isModalOpen: false,
    userlist: [],
    checked:false,
    step:'1'
  };

  changHandler(value, type){
    this.setState({
      [type]: value
    })
  }

  //切换登录方式
  changlogintype(data){
    this.setState({
      type:data,
      mobile:'',
      vcode:'',
      name:'',
      password: ''
    })
  }
  getToken(){
    fixToken().then(res=>{
      loginStatusSelect().then(res=>{
        if (res.statecode === 0) {
          this.setState({
            step:res.records[0].step
          })
        }
      })
    })
  }

  login(){
    if(!this.state.loginid || !this.state.password){
      message.error('请完善登录信息');
      return
    }
    const data = {
      loginid:this.state.loginid,
      password:this.state.password
    }
    postLogin(data).then(res=>{
      if(res.statecode === 0) {
        let userInfo = res.records;
        sessionStorage.setItem('login', true);
        setStorage('userInfo', userInfo);
        this.props.setUserInfo(userInfo);
        this.props.setBreadcrumb([]);
        if (userInfo[0].clerklist.length > 1) {
          this.setState({
            isModalOpen: true,
            userlist:userInfo[0].clerklist
          })
        } else if (userInfo[0].clerklist.length === 1) {
          setStorage('menu', userInfo[0].menulist);
          this.props.setMenu(userInfo[0].menulist);
          this.selectPersonType(userInfo[0].clerklist[0].id,userInfo[0].clerklist[0].clerklevel)
        } else {
          message.error('该用户暂无角色无法登陆');
          this.handleCancel()
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  gotozn(){
    this.props.history.push({
      pathname: '/register',
    });
    // window.open('/fc/down/7.博物馆运行评估信息系统使用指南.pdf','_blank')
  }

  loginphone(){
    if(!this.state.mobile){
      message.error('请输入登录的手机号码');
      return
    }
    const reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(this.state.mobile)) {
      message.error('请输入正确的手机号码');
      return
    }

    if(!this.state.vcode){
      message.error('请输入手机验证码');
      return
    }
    const data = {
      mobile:this.state.mobile,
      vcode:this.state.vcode
    }
    loginPhone(data).then(res=>{
      if(res.statecode === 0) {
        let userInfo = res.records;
        setStorage('userInfo', userInfo);
        sessionStorage.setItem('login', true);
        this.props.setBreadcrumb([]);
        this.props.setUserInfo(userInfo);
        if (userInfo[0].clerklist.length > 1) {
          this.setState({
            isModalOpen: true,
            userlist:userInfo[0].clerklist
          })
        } else if (userInfo[0].clerklist.length === 1) {
          setStorage('menu', userInfo[0].menulist);
          this.props.setMenu(userInfo[0].menulist);
          this.selectPersonType(userInfo[0].clerklist[0].id,userInfo[0].clerklist[0].clerklevel)
        } else {
          message.error('该用户暂无角色无法登陆');
          this.handleCancel()
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  selectPersonType(data,type){
    selecttype({uid:data}).then(res=>{
      let userInfo = res.records[0];
      setStorage('userList', userInfo);
      this.props.setUserList(userInfo);
      sessionStorage.setItem('login', true)
      if (type == 8 || type == 9) {
        this.props.history.push({
          pathname: '/home',
        });
        window.location.reload(true)
      } else if (type == 3 || type == 4 || type == 16) {
        this.props.history.push({
          pathname: '/homeCentral',
        });
        window.location.reload(true)
      } else if (type == 10 || type == 11) {
        this.props.history.push({
          pathname: '/homeScore',
        });
        window.location.reload(true)
      } else {
        this.props.history.push({
          pathname: '/homeProvince',
        });
        window.location.reload(true)
      }
    })
  }


  handleCancel(){
    this.setState({
      isModalOpen: false,
    })
    loginout().then(res=>{
      if (res.statecode === 0) {
        // 退出
        setStorage('userInfo', null);
        this.props.setUserInfo(null);
        setStorage('userList', null);
        this.props.setUserList(null);
      } else {
        message.error(res.statemessage);
      }
    })
  }

  menuClick(data){
    const d = {
      uid:data
    }
    selecttype(d).then(res=>{
      let userInfo = res.records[0];
      setStorage('userList', userInfo);
      this.props.setUserList(userInfo);
      sessionStorage.setItem('login', true)
      setStorage('menu', userInfo.menulist);
      this.props.setMenu(userInfo.menulist);
      if (userInfo.clerklevel == 8 || userInfo.clerklevel == 9) {
              window.location.href='/#/home'
              // this.props.history.push({
              //   pathname: '/home',
              // });
              // window.location.reload(true)
      } else if (userInfo.clerklevel == 3 || userInfo.clerklevel == 4 || userInfo.clerklevel == 16) {
              // this.props.history.push({
              //   pathname: '/libraryManageHome',
              // });
              // window.location.reload(true)
        window.location.href='/#/homeCentral'
      } else if (userInfo.clerklevel == 10 || userInfo.clerklevel == 11) {
              // this.props.history.push({
              //   pathname: '/homeScore',
              // });
              // window.location.reload(true)
        window.location.href='/#/homeScore'

      } else {
        // this.props.history.push({
        //   pathname: '/homeProvince',
        // });
        // window.location.reload(true)
        window.location.href='/#/homeProvince'

      }
    })
  }

  onChange(){
    this.setState({
      checked: !this.state.checked
    })
  }

  opensc(){
    window.location.href = 'http://rep.chinamuseum.org.cn/fc/down/博物馆定级评估系统用户使用指南.pdf'
  }

  componentDidMount(){
      this.getToken()
  }

  render(){
    return (
      <div className='login'>
        <div className='login-title'>
         <span>博物馆定级评估系统</span>
        </div>
        <div className='flex login-content'>
          <div className='login-form'>
            <div className='flex login-form-title'>
              <div className='login-form-title-name'>
                <span className={this.state.type==='phone'?'activeted':'normal'} onClick={() => this.changlogintype('phone')} style={{color:this.state.type === 'phone'?'#000000':''}}>手机登录</span>
                <span style={{margin:'0 20px'}}>|</span>
                <span className={this.state.type==='count'?'activeted':'normal'} onClick={() => this.changlogintype('count')} style={{color:this.state.type === 'count'?'#000000':''}}>账号登录</span>
              </div>
              <i className='fa fa-edit'></i>
            </div>
            <div className='login-form-content'>
              {this.state.type === 'count'?<div>
                <CInput value={this.state.loginid} placeholder='请输入用户名' onChange={(value) => this.changHandler(value, 'loginid')} onEnter={this.login} />
                <CInput type='password' value={this.state.password} placeholder='请输入密码' onChange={(value) => this.changHandler(value, 'password')} onEnter={this.login} />
                <CButton className='login-button' size='larger' block type='primary' onClick={this.login}>登 录</CButton>
                {this.state.step === '1' && <div className='gotoregidter' style={{textAlign:'center'}}>
                  <span style={{color:'#3c8dbc',cursor:'pointer'}}>申报单位首次登录请先完成</span><span style={{color:'orange',cursor:'pointer',marginLeft:'5px',fontSize:'20px'}} onClick={()=>{this.gotozn()}}>注册</span>
                </div>}
              </div>:
              <div>
                  <CInput value={this.state.mobile} placeholder='请输入手机号'  onChange={(value)=>this.changHandler(value, 'mobile')}/>
                <div className='phone-block'>
                  <CInput value={this.state.vcode} placeholder='请输入验证码' onChange={(value) => this.changHandler(value, 'vcode')} onEnter={this.login} />
                  <Time seconds={60} mobile={this.state.mobile} />
                </div>
                <CButton className='login-button' size='larger' block type='primary' onClick={()=>this.loginphone()}>登 录</CButton>
                {this.state.step === '1' && <div className='gotoregidter' style={{textAlign:'center'}}>
                  <span style={{color:'#3c8dbc',cursor:'pointer'}}>申报单位首次登录请先完成</span><span style={{color:'orange',cursor:'pointer',marginLeft:'5px',fontSize:'20px'}} onClick={()=>{this.gotozn()}}>注册</span>
                </div>}
                {/*<div style={{textAlign:'center'}}>*/}
                {/*  如需帮助请下载  <span style={{color:'orange',cursor:'pointer'}} onClick={()=>{this.opensc()}}>操作指南</span>*/}
                {/*</div>*/}
              </div>
              }
            </div>
          </div>
        </div>
        <div className='login-footer'>
          <div style={{marginLeft:'30px'}}>技术支持：15801346528</div>
          <div style={{marginLeft:'30px'}}>博物馆评估办公室邮箱：bwgpg_cma@sina.com</div>
        </div>
        <Modal title="请选择登录的角色"
               visible={this.state.isModalOpen}
               onCancel={this.handleCancel}
               footer={[]}
        >
            <div className='loginlist'>
              {
                this.state.userlist.map((item, index)=>
                <span onClick={() => this.menuClick(item.id)}>{item.realname}</span>
                )
              }
            </div>
        </Modal>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    menu:state.menu,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setUserList:bindActionCreators(setUserList,dispatch),
    setMenu: bindActionCreators(setMenu,dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),

  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Login);
